import { ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Groupmanagement = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  group_name?:string
  chapter_name?:string
 
 
}

export type GroupmanagementsQueryResponse = Response<Array<Groupmanagement>>

export const initialGroupmanagement: Groupmanagement = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',

}
